import * as React from "react";
import Notifications from "./Notifications";
import styles from "./HeaderProfile.module.scss";
import ProfileMenu from "./ProfileMenu";

export const HeaderProfile = () => {
  return (
    <>
      <div className={`d-flex align-items-center top-right m-3 me-4`}>
        <div
          className={`me-2 position-relative cursor-pointer ${styles["notifications-border"]}`}
        >
          <Notifications />
        </div>
        <div
          className={`me-2 position-relative outlook-menu cursor-pointer ${styles["notifications-border"]}`}
        >
          <ProfileMenu />
        </div>
      </div>
    </>
  );
};
